module.exports = __webpack_public_path__ + "assets/img/block-right-hover-b0cd81c7.png";